import React, { useEffect, useRef, useState } from 'react'
import {
  Box,
  Button,
  Slide,
  Paper,
  IconButton,
  Card,
  Badge,
  CircularProgress,
  Stack,
  ClickAwayListener,
  Grow,
  Tooltip,
} from '@material-ui/core'
import { styled } from '@material-ui/styles'
import CloseIcon from '@material-ui/icons/Close'
import ChatIcon from '@material-ui/icons/Chat'
import MessageIcon from '@material-ui/icons/Message'
import ChatMain from './ChatMain'
import ChatSidebarSignWise from './ChatRightScreen/ChatSidebarSignWise'
import ChatScreenWindow from './ChatLeftScreen/ChatScreenWindow'
import { useDispatch } from 'react-redux'
import { getContacts, getConversations } from 'src/redux/slices/chat'
import IMG from '../../../Gif/apple-touch-icon.png'
import { MBadge } from 'src/components/@material-extend'
import axios from 'axios'
import { DOMAIN, REST_API_END_POINT, REST_API_IO, STATUS_OPTIONS } from 'src/constants/DefaultValues'
// import Draggable from 'react-draggable'
import { io } from 'socket.io-client'
// import owlNotification from '../../../assets/owl-notif.png'
// Styled Button for Floating Chat
const FloatingButton = styled(Button)(({ theme }) => ({
  position: 'fixed',
  bottom: 25,
  right: 25,
  zIndex: 1000,
  width: '65px',
  height: '65px',
  minWidth: '65px',
  borderRadius: '50%',
  boxShadow: '0px 4px 20px rgba(28, 134, 255, 0.5)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  background: 'linear-gradient(135deg, rgba(59, 130, 246, 0.1) 0%, rgba(147, 197, 253, 0.2) 100%)',
  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  cursor: 'pointer',
  border: '2px solid rgba(59, 130, 246, 0.3)',
  backdropFilter: 'blur(10px)',
  '&:hover': {
    background: 'linear-gradient(135deg, rgba(59, 130, 246, 0.2) 0%, rgba(147, 197, 253, 0.3) 100%)',
    transform: 'scale(1.15) rotate(5deg)',
    boxShadow: '0px 8px 30px rgba(59, 130, 246, 0.4), 0px 0px 20px rgba(147, 197, 253, 0.3)',
    border: '2px solid rgba(59, 130, 246, 0.5)',
  },
  '&:active': {
    transform: 'scale(0.95)',
    transition: 'all 0.1s ease',
  },
  '& *': {
    pointerEvents: 'none',
  },

  // Responsive styles
  [theme.breakpoints.down('md')]: {
    right: 15,
    bottom: 15,
    width: '60px',
    height: '60px',
    minWidth: '60px',
  },
}))

// Styled Chat Popup Window
const PopupChat = styled(Paper)(({ theme }) => ({
  position: 'absolute',
  top: 150,
  right: 70,
  zIndex: 1100,
  width: 'fit-content',
  transformOrigin: 'bottom right',
  boxShadow: '0px 20px 40px rgba(59, 130, 246, 0.15), 0px 0px 20px rgba(147, 197, 253, 0.1)',
  borderRadius: '16px',
  overflow: 'hidden',
  [theme.breakpoints.down('md')]: {
    right: 0,
    top: 100,
    width: '100vw',
    height: '80vh',
    borderRadius: '16px 16px 0 0',
  },
}))

export default function FloatingChat() {
  const [open, setOpen] = useState(false)
  const [openCompose, setCompose] = useState(true)
  const dispatch = useDispatch()
  const user = localStorage.getItem('user')
  const userData = JSON.parse(user)
  const isAdmin = true || userData.user_type === 1
  const [teamMembers, setTeamMembers] = useState([])
  const [chatCount, setChatCount] = useState(0)
  console.log('chatCount+++++++++++', chatCount)
  const [selectedContact, setSelectedContact] = useState(null)
  const [renderChat, setRenderChat] = useState(false)
  const [loading, setLoading] = useState(true)
  const [status, setStatus] = useState(null)
  const [refreshStatus, setRefreshStatus] = useState(false)
  const [showHistory, setShowHistory] = useState(true)
  const [chatOpenTime, setChatOpenTime] = useState(null)
  const [historyMessage, setHistoryMessage] = useState([])
  const [selectedChatLogId, setSelectedChatLogId] = useState(null)
  const [newChat, setNewChat] = useState(false)
  const [position, setPosition] = useState(null)
  const isDragging = useRef(false)
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [isDraggingNow, setIsDraggingNow] = useState(false);
  const socketRef = useRef(null);
  const owlNotification = `${process.env.PUBLIC_URL}/favicon/owl-notif.png`;
  const [onChatScreen,setOnChatScreen]=useState(false);
  const [mobileChat,setMobileChat]=useState(true);
  const canPlaySound = useRef(false); 
  const originalTitle = useRef(document.title);
  const blinkIntervalRef = useRef(null);
  const originalFavicon = useRef(null);
  const setFavicon = (iconURL) => {
    let link = document.querySelector("link[rel*='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    link.href = iconURL + '?v=' + new Date().getTime();
  };
  
  useEffect(() => {
    let notificationSound = new Audio('/sounds/text_message.mp3');
    let notificationSound2 = new Audio('/sounds/whatsapp_notification.mp3');
    if(userData.user_id===667){
      notificationSound = new Audio('/sounds/barking_dog.mp3');
      notificationSound2 = new Audio('/sounds/barking_dog.mp3');
    }
    const enableSound = () => {
      canPlaySound.current = true;
      notificationSound.load();
      notificationSound2.load();
    };
    
    ['click', 'keydown', 'touchstart'].forEach((eventName) => {
      window.addEventListener(eventName, enableSound, { once: true });
    });
    socketRef.current = io(REST_API_IO, { path: "/socket.io", transports: [ "websocket", "polling"], secure: true });

    console.log('chatCount+++++++++++', )
    socketRef.current.on("message", (msg) => {
      if(msg?.domain===DOMAIN){

      let receivedConversationId = String(msg.conversationId);
      let senderConversationId = String(msg.senderId);
      let currentUserId = userData.user_id;
      const isOwnMessage = senderConversationId === String(currentUserId);
      const isGroupChat = Array.isArray(msg.participants) && msg.participants.length > 0;
      let userID =String(userData.user_id);
      if (msg.conversationId?.startsWith("user_")) {

        if (!userID.startsWith("user_")) userID = `user_${userID}`;
        if (!receivedConversationId.startsWith("user_")) receivedConversationId = `user_${receivedConversationId}`;
        if (!senderConversationId.startsWith("user_")) senderConversationId = `user_${senderConversationId}`;
        console.log('chatCount+++++++++++',receivedConversationId,userID,isOwnMessage,canPlaySound.current )
        if (receivedConversationId ===userID && !isOwnMessage ) {
          if (!open && !onChatScreen && canPlaySound.current) {
            notificationSound.play().catch((e) => console.error("Failed to play sound:", e));
            if (!originalFavicon.current) {
              const link = document.querySelector("link[rel~='icon']");
              originalFavicon.current = link?.href;
            }
        
            let showBlue = true;
            console.log('showBlue+++++++++', showBlue)
            blinkIntervalRef.current = setInterval(() => {
              setFavicon(showBlue
                ? owlNotification
                : originalFavicon.current);
              showBlue = !showBlue;
            }, 1000);
          }
        // if (receivedConversationId === conversationId) {
        //   fetchMessages(conversationId);
        //   setRenderChat(!renderChat);
        //   handleRefresh();
        // } else {
        //   setTimeout(() => {
        //     // notificationSound.play().catch((e) => console.error("Failed to play sound:", e));
        //     fetchMessages(conversationId);
        //     setRenderChat(!renderChat);
        //     handleRefresh();
        //   }, 1000);
        // }    
        if(open && onChatScreen && canPlaySound.current){
        notificationSound2.play().catch((e) => console.error("Failed to play sound:", e));
        // document.title = '● New Message - ' + originalTitle.current;
        fetchData()
        }
      }
      }else{
        if(isGroupChat){
          
          const participantIds = msg.participants.map(p => p.user_id);
          let  isRecipientInGroup = participantIds.includes(currentUserId);
              if (isRecipientInGroup && !isOwnMessage) {
                if (!open && !onChatScreen && canPlaySound.current) {
                notificationSound.play().catch((e) => console.error("Failed to play sound:", e));
                fetchData()
                }
            if (open && onChatScreen && canPlaySound.current ) {
              notificationSound2.play().catch((e) => console.error("Failed to play sound:", e));
              fetchData()
            }
          }
        }
      }  
    }});
    
    return () => {
      socketRef.current.disconnect();
      if (blinkIntervalRef.current) {
        clearInterval(blinkIntervalRef.current);
        blinkIntervalRef.current = null;
      }
      if (originalFavicon.current) {
        setFavicon(originalFavicon.current);
      }
    };
  }, [userData]);

useEffect(() => {
  const handleFocus = () => {
    if (blinkIntervalRef.current) {
      clearInterval(blinkIntervalRef.current);
      blinkIntervalRef.current = null;
    }
    if (originalFavicon.current) {
      setFavicon(originalFavicon.current);
    }
    document.title = originalTitle.current;
  };

  window.addEventListener('focus', handleFocus);
  return () => {
    window.removeEventListener('focus', handleFocus);
  };
}, []);

  
console.log('owlNotification resolved path:', owlNotification);


  const isMobile = windowWidth < 768
  const isMd = windowWidth < 900

useEffect(() => {
  const handleResize = () => {
    setWindowWidth(window.innerWidth);
  };

  window.addEventListener('resize', handleResize);
  return () => window.removeEventListener('resize', handleResize);
}, []);


  const clampPosition = (x, y) => ({
    x: Math.min(Math.max(0, x), window.innerWidth - 60),
    y: Math.min(Math.max(0, y), window.innerHeight - 60),
  })

  const fetchSavedPosition = async () => {
    try {
      const response = await axios.post(
        `${REST_API_END_POINT}get-chat-position`,
        {
          userId: userData.user_id,
        },
      )

      if (response.data.status === 1) {
        const { position_x, position_y } = response?.data
        if (
          position_x !== null &&
          position_y !== null &&
          position_x !== undefined &&
          position_y !== undefined
        ) {
          const clamped = clampPosition(position_x, position_y)
          setPosition(clamped)
        } else {
          const fallback = {
            x: window.innerWidth - 100,
            y: window.innerHeight - 150,
          }
          setPosition(fallback)
        }
      }
    } catch (err) {
      console.error('Failed to fetch saved position:', err)
      const fallback = {
        x: window.innerWidth - 100,
        y: window.innerHeight - 150,
      }
      setPosition(fallback)
    }
  }

  // useEffect(() => {
  //   // fetchSavedPosition()
  //   const clamped = clampPosition(314, 15)
  //   setPosition(clamped)
  // }, [isMd])

  const handleDrag = (e, data) => {
    isDragging.current = true
    setIsDraggingNow(true)
    setPosition({ x: data.x, y: data.y })
  }

  const handleDragStop = async (e, data) => {
    setTimeout(() => {
      isDragging.current = false
      setIsDraggingNow(false)
    }, 200)

    const clamped = clampPosition(data.x, data.y)
    setPosition(clamped)
    setPosition(clamped)

    try {
      await axios.post(`${REST_API_END_POINT}update-chat-position`, {
        userId: userData.user_id,
        chat_position_x: data.x,
        chat_position_y: data.y,
      })
      console.log(' Chat position saved:', clamped)
    } catch (err) {
      console.error(' Failed to save position:', err)
    }
  }

  const fetchStatus = async () => {
    try {
      const response = await axios.post(
        `${REST_API_END_POINT}chat/get-chat-status-by-userid`,
        { userId: userData.user_id },
      )
      if (response.data.status === 1) {
        const fetchedStatus = response.data.result.chat_status
        const filteredStatus = STATUS_OPTIONS?.find(
          (item) => item.id == fetchedStatus,
        )
        console.log('newStatus---filteredStatus-1--', filteredStatus)
        setStatus(filteredStatus)
        console.log('Status set successfully')
      } else {
        console.log('Status not found')
      }
    } catch (error) {
      console.log('Error finding status : ', error)
    }
  }

  useEffect(() => {
    fetchStatus()
  }, [refreshStatus, open])
  const fetchData = async (updateSelctedContact = false) => {
    if (isAdmin && userData) {
      try {
        const response = await axios.post(
          `${REST_API_END_POINT}chat/get-chat-list`,
          {
            usersId: userData.user_id,
            usersType: userData.user_type,
            // page:page+1,rowsPerPage,search:filterName,
          },
        )
        if (response.data.data) {
          const newData = response.data.data
          const TotalUnread = response.data.totalUnreadCount
          setTeamMembers(newData)
          setChatCount(TotalUnread)
          if (updateSelctedContact) {
            const filteredData = newData.find(
              (member) =>
                member?.new_conversation_id ===
                selectedContact?.new_conversation_id,
            )
            console.log('selectedContact---', selectedContact)
            console.log('filteredData---', filteredData)
            setSelectedContact(filteredData)
          }
        } else {
          setTeamMembers([])
          setChatCount(0)
        }
      } catch (error) {
        console.log('Error fetching data: ', error)
      } finally {
        setLoading(false)
      }
    }
  }

  useEffect(() => {
    fetchData()
  }, [open])

  useEffect(() => {
    fetchData(true)
  }, [renderChat])

  const handleRefresh = () => {
    fetchData(true)
  }

  const refreshChat = () => {
    setRenderChat(!renderChat)
  }

  useEffect(() => {
    dispatch(getConversations())
    dispatch(getContacts())
  }, [dispatch])

  const togglePopup = () => {
    setOpen(!open)
    setOnChatScreen(!onChatScreen)
    setCompose(true)
    setShowHistory(false)
    setSelectedContact(null)
    // console.log('showHistoryshowHistory',!showHistory,selectedContact)
  }
  const openChat = () => {
    setCompose(false)
  }

  return (
    <>
      {/* <FloatingButton onClick={togglePopup}>
        <Badge badgeContent={3} color="error" overlap="circular">
          <Box
            component="img"
            src={IMG}
            alt="LOGO"
            sx={{ width: 45, height: 45, objectFit: 'cover', mt: 0.5 }}
          />
        </Badge>
      </FloatingButton> */}

      {/* {position && !isMobile && (
        <Draggable
          bounds="body"
          position={position}
          onDrag={handleDrag}
          onStop={handleDragStop}
        >
          <div
            className="drag-wrapper"
            style={{ position: 'fixed', zIndex: 9999,cursor: isDraggingNow ? 'grabbing' : 'grab', }}
          >
            <FloatingButton
              onClick={() => {
                if (!isDragging.current) togglePopup()
              }}
            >
              <Badge badgeContent={chatCount} color="error" overlap="circular">
                <Box
                  component="img"
                  src={IMG}
                  alt="LOGO"
                  sx={{ width: 45, height: 45, objectFit: 'cover', mt: 0.5 }}
                />
              </Badge>
            </FloatingButton>
          </div>
        </Draggable>
      )} */}
      
        <Tooltip title="Skyniche Chat Support" placement="left" arrow>
          <FloatingButton
            data-testid="floating-chat-button"
            onClick={() => {
              if (!isDragging.current) togglePopup()
            }}
          >
            <Badge badgeContent={chatCount} color="error" overlap="circular">
              <Box sx={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                {/* Your brand cloud icon */}
                <Box
                  component="img"
                  src={IMG}
                  alt="Skyniche Chat"
                  sx={{ 
                    width: 60, 
                    height: 60, 
                    objectFit: 'contain',
                    filter: 'drop-shadow(0 1px 2px rgba(0,0,0,0.2))'
                  }}
                />
                {/* Small chat indicator */}
                <Box
                  sx={{
                    position: 'absolute',
                    bottom: -2,
                    right: -2,
                    width: 25,
                    height: 25,
                    borderRadius: '50%',
                    backgroundColor: '#4CAF50',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    border: '2px solid white',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.3)'
                  }}
                >
                  <MessageIcon sx={{ fontSize: 10, color: 'white' }} />
                </Box>
              </Box>
            </Badge>
          </FloatingButton>
        </Tooltip>
      

      {/* {isMobile && (
        <div style={{ position: 'fixed', bottom: 80, right: 80, zIndex: 9999,cursor: isDragging.current ? 'grabbing' : 'grab', }}>
          <FloatingButton onClick={togglePopup}>
            <Badge badgeContent={chatCount} color="error" overlap="circular">
              <Box
                component="img"
                src={IMG}
                alt="LOGO"
                sx={{ width: 45, height: 45, objectFit: 'cover', mt: 0.5 }}
              />
            </Badge>
          </FloatingButton>
        </div>
      )} */}

      <Slide 
        direction="up" 
        in={open} 
        mountOnEnter 
        unmountOnExit
        timeout={400}
        easing={{
          enter: 'cubic-bezier(0.34, 1.56, 0.64, 1)',
          exit: 'cubic-bezier(0.4, 0, 0.2, 1)',
        }}
      >
        <PopupChat>
          {/* {loading ? 
              <Stack alignItems='center' justifyContent='center'>
                <CircularProgress color="primary" variant="indeterminate" />
              </Stack>: */}
          {/* {isMobile ?
          (<Card sx={{ height: '72vh', display: 'flex' }}>
            {mobileChat ?<ChatSidebarSignWise
              openCompose={openCompose}
              setCompose={setCompose}
              setOpen={setOpen}
              teamMembers={teamMembers}
              setSelectedContact={setSelectedContact}
              selectedContact={selectedContact}
              refreshChat={refreshChat}
              setRenderChat={setRenderChat}
              renderChat={renderChat}
              status={status}
              setStatus={setStatus}
              refresh={refreshStatus}
              setRefresh={setRefreshStatus}
              setShowHistory={setShowHistory}
              showHistory={showHistory}
              chatOpenTime={chatOpenTime}
              setChatOpenTime={setChatOpenTime}
              setHistoryMessage={setHistoryMessage}
              historyMessage={historyMessage}
              selectedChatLogId={selectedChatLogId}
              setSelectedChatLogId={setSelectedChatLogId}
              setNewChat={setNewChat}
              newChat={newChat}
              handleRefresh={handleRefresh}
              setMobileChat={setMobileChat}
            />:
            <ChatScreenWindow
            setOnChatScreen={setOnChatScreen}
              openCompose={openCompose}
              setCompose={setCompose}
              teamMembers={teamMembers}
              contact={selectedContact}
              setSelectedContact={setSelectedContact}
              refreshChat={refreshChat}
              setRenderChat={setRenderChat}
              renderChat={renderChat}
              handleRefresh={handleRefresh}
              setShowHistory={setShowHistory}
              showHistory={showHistory}
              chatOpenTime={chatOpenTime}
              setChatOpenTime={setChatOpenTime}
              setHistoryMessage={setHistoryMessage}
              historyMessage={historyMessage}
              selectedChatLogId={selectedChatLogId}
              setSelectedChatLogId={setSelectedChatLogId}
              setNewChat={setNewChat}
              newChat={newChat}
            />}
          </Card>)
          :( */}
          <Card sx={{ height: '72vh', display: 'flex' }}>
            <ChatSidebarSignWise
              openCompose={openCompose}
              setCompose={setCompose}
              setOpen={setOpen}
              teamMembers={teamMembers}
              setSelectedContact={setSelectedContact}
              selectedContact={selectedContact}
              refreshChat={refreshChat}
              setRenderChat={setRenderChat}
              renderChat={renderChat}
              status={status}
              setStatus={setStatus}
              refresh={refreshStatus}
              setRefresh={setRefreshStatus}
              setShowHistory={setShowHistory}
              showHistory={showHistory}
              chatOpenTime={chatOpenTime}
              setChatOpenTime={setChatOpenTime}
              setHistoryMessage={setHistoryMessage}
              historyMessage={historyMessage}
              selectedChatLogId={selectedChatLogId}
              setSelectedChatLogId={setSelectedChatLogId}
              setNewChat={setNewChat}
              newChat={newChat}
              handleRefresh={handleRefresh}
            />
            <ChatScreenWindow
            setOnChatScreen={setOnChatScreen}
              openCompose={openCompose}
              setCompose={setCompose}
              teamMembers={teamMembers}
              contact={selectedContact}
              setSelectedContact={setSelectedContact}
              refreshChat={refreshChat}
              setRenderChat={setRenderChat}
              renderChat={renderChat}
              handleRefresh={handleRefresh}
              setShowHistory={setShowHistory}
              showHistory={showHistory}
              chatOpenTime={chatOpenTime}
              setChatOpenTime={setChatOpenTime}
              setHistoryMessage={setHistoryMessage}
              historyMessage={historyMessage}
              selectedChatLogId={selectedChatLogId}
              setSelectedChatLogId={setSelectedChatLogId}
              setNewChat={setNewChat}
              newChat={newChat}
            />
          </Card>
          {/* )} */}
          {/* } */}
        </PopupChat>
      {/* </Grow> */}
      </Slide>
    </>
  )
}
